import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { MDBBox, MDBContainer } from 'mdbreact';
import dotenv from 'dotenv';

import NavbarPage from './Components/Navbar';
import FooterPage from './Components/Footer';
import PortalHome from './Pages/PortalHome';
import UserContextProvider from './Components/UserContext';

import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import UserPage from './Pages/UserPage';
import EventPage from './Pages/EventPage';
import Admin from './Pages/Admin';

import './App.css';

export default function App() {
  dotenv.config();
  const baseURL = process.env.REACT_APP_API_BASEURL;
  return (
    <UserContextProvider>
      <MDBBox
        display="flex"
        flex="column"
        style={{ position: 'relative', minHeight: '100vh' }}
      >
        <BrowserRouter basename="/hours_portal">
          <NavbarPage />
          <MDBContainer
            fluid
            style={{
              flexGrow: 1, display: 'flex', paddingLeft: '0', paddingRight: '0',
            }}
          >
            <Switch>
              <Route
                exact
                path="/EventsPage"
              >
                <EventPage />
              </Route>
              <Route exact path="/profile">
                <UserPage baseURL={baseURL} />
              </Route>
              <Route exact path="/admin">
                <Admin />
              </Route>
              <Route path="/">
                <PortalHome baseURL={baseURL} />
              </Route>
            </Switch>
          </MDBContainer>
          <div
            style={{
              position: 'absolute',
              bottom: '0',
              width: '100%',
              height: '2.5rem',
            }}
          >
            <FooterPage />
          </div>
          {' '}
        </BrowserRouter>
        {' '}
      </MDBBox>
      {' '}
    </UserContextProvider>
  );
}
